import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { SavedFilter } from 'core/table/interfaces/TablePersistence'

export const useGetTableFilters = (): [(tableName: string) => Promise<SavedFilter[]>, Status<SavedFilter[]>] => {
  const [request, status] = useFetchRefactored<SavedFilter[]>({
    emptyValue: undefined,
  })

  const fetchTableFilters = useCallback(
    tableName =>
      request({
        method: 'get',
        url: `/user/tables/${tableName}/filters`,
      }),
    [request],
  )

  return [fetchTableFilters, status]
}

export default useGetTableFilters
